import {useDataSource} from "src/core/data-sources/decorators/withData";
import WPAboutItemsDataSource from "../../../../../common/components/collections/menu/data-sources/aboutItemsDataSource";
import useSite from "../../../../../sites/hooks/useSite";

function useAboutItems() {
  const site = useSite();
  dataSource.setContentHost(site.getContentHost());
  const {data: aboutItems} = useDataSource(
    {},
    {
      dataSource: dataSource,
    }
  );

  return [aboutItems];
}

const dataSource = new WPAboutItemsDataSource();

export default useAboutItems;
